import { Api } from '@/core/api.js'
const api = new Api()

// initial state
const state = {
  requests: [],
  confirm: false
}

// getters
const getters = {
  getRequests: (state, getters, rootState) => {
    return state.requests
  },
  getPendingRequests: (state, getters, rootState) => {
    var counter = 0
    for (var request in state.requests) {
      if (parseInt(state.requests[request].status) == 1) {
        counter++
      }
    }
    return counter
  },
  getConfirm: (state, getters, rootState) => {
    return state.confirm
  }
}

// actions
const actions = {
  loadRequests ({ commit }) {
    return api.get('admin/mop_requests').then(function (response) {
      if (response.status) {
        var data = response.data

        return commit('setRequests', data)
      }
    })
  },
  update ({ commit }, data) {
    return api.post('mop_requests/update/' + data.id, data.params).then(function (data) {
      console.log(data)
    })
  },
  updateAutoConfirm ({ commit }, value) {
    var confirm = value ? 1 : 0
    return api.post('mop_request/update_confirm/' + confirm, {}).then(function (response) {
      if (response.status) {
        commit('setConfirm', value)
      }
      return response
    })
  },
  loadConfirm ({ commit }) {
    return api.get('mop_request/get_confirm').then(function (response) {      
      let confirmValue = false
      if (response.status && response.data) {
        confirmValue = response.data.status
        
        if (confirmValue === '1' || confirmValue === 1 || confirmValue === true) {
          confirmValue = true
        } else {
          confirmValue = false
        }
      }
      commit('setConfirm', confirmValue)
      
      return response
    })
  }
}

// mutations
const mutations = {
  setRequests (state, requests) {
    state.requests = requests
  },
  setConfirm (state, confirm) {
    state.confirm = confirm
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
